













import { Component, Vue, Prop } from 'vue-property-decorator';
import PortalNotificationSkeltonLoader from '@/components/atoms/skelton/PortalNotificationSkeltonLoader.vue';
import PortalNotificationPanel from '@/components/organisms/PortalNotificationPanel.vue';

interface Panel {
  icon: string;
  title: string;
}

@Component({
  components: { PortalNotificationSkeltonLoader, PortalNotificationPanel },
})
export default class PortalNotificationBody extends Vue {
  @Prop()
  private isAnnouncementV1Used!: boolean;

  @Prop()
  private loading!: boolean;

  @Prop()
  private notificationHtml!: string | null;

  @Prop()
  private eventHtml!: string | null;
}
